







































































import Vue from 'vue';

import { SearchResult } from '@/services/Search';
import Services from '@/services';

import LoadingDots from '@/components/LoadingDots.vue';

export default Vue.extend({
    components: {
        LoadingDots,
    },
    directives: {
        stopSearch: {
            bind: el => el.addEventListener('click', () => Services.$search.stop()),
        },
    },
    mounted() {
        this.$search.setSearchResultsContainer(this.$el as HTMLElement);
    },
    destroyed() {
        this.$search.setSearchResultsContainer(null);
    },
    methods: {
        resultButtonTitle(result: SearchResult): string {
            const title = result.title;

            if (!result.exists())
                return title;

            const status = result.watched ? 'Watched' : 'Watch later';

            return `${title} (${status})`;
        },
    },
});
